import { ServiceType } from '@rover/constants/src/translations/service.constants';

const HOSTED_SERVICE_TYPES: ReadonlySet<string> = new Set([
  ServiceType.OVERNIGHT_BOARDING,
  ServiceType.DOGGY_DAY_CARE,
]);

/**
 * Returns true if the service type is a "hosted" service where
 * the pet stays at the sitter's home (boarding, day care).
 * Returns true for undefined (default to showing the section).
 */
export const isHostedServiceType = (serviceType: string | undefined): boolean => {
  if (serviceType === undefined) return true;
  return HOSTED_SERVICE_TYPES.has(serviceType);
};
